import React, { useState, useEffect, createContext } from "react";
import { ezsServiceIds, idfServiceIds } from "./config/UserServicesList";
import { useAreServicesActive, useAreServicesAndFeatureActive } from "./util/CommonServices";
import { useDispatch, useSelector } from "react-redux";
import * as NextStepFlowAction from "./store/nextStepFlowService/actions";
import * as ConfigurationAction from "./store/configurationService/actions";
import { getFlowByName, BUSINESS_PROFILE_STATUS, FLOW_STEP_COMPLETED_STATUS, ADD_YOUR_ADDITIONAL_BUSINESS_INFORMATION } from "./config/FlowName";
import { ApplicationState } from "./store";
import * as Service from "./store/service";
import * as LoginTypes from "./store/loginService/types";
import * as LoginActions from "./store/loginService/actions";
import { useHistory } from "react-router-dom";

export const CommonContext = createContext({});

const CommonContextProvider = (props: any) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const service = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.userServices
            ? state.loggedInUser && state.loggedInUser.userServiceDetails.userServices
            : []
    );
    const creditHistory = useSelector((state: ApplicationState) => {
        return state.creditHistoryData.creditHistoryData;
    });
    const hasPurchaseCreditReport = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.hasPurchaseCreditReport);
    const hasOneTimeReport = useSelector((state: ApplicationState) => state.creditHistoryData && state.creditHistoryData.hasOneTimeReport);
    const hasOneTimeScore = useSelector((state: ApplicationState) => state.creditHistoryData && state.creditHistoryData.hasOneTimeScore);

    const creditScoreAndTrackerServiceList = [
        ezsServiceIds.monthlyCreditScore,
        ezsServiceIds.quarterlyCreditScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuCanadaCreditScore,
        idfServiceIds.threeBureauCreditScores,
        idfServiceIds.transUnionCreditScore,
        ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        idfServiceIds.creditScoreTracker,
        ezsServiceIds.tuCreditScoreTracker,
        ezsServiceIds.tuCanadaCreditScoreTracker,
        ezsServiceIds.expMonthlyCreditScoreTracker,
        ezsServiceIds.tuCanadaMonthlyCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,
        ezsServiceIds.tuCanadaAnnualCreditReportWithScore,
        ezsServiceIds.tuCanadaOneTimeCreditReportWithScore,
    ];

    const creditReportServiceList = [
        ezsServiceIds.experianCreditReport,
        ezsServiceIds.experianCreditReportwithScore,
        ezsServiceIds.experianAnnualCreditReportWithScore,
        ezsServiceIds.creditReportForEachOf3Bureaus,
        ezsServiceIds.creditReportForEachOf3BureausWithScore,
        ezsServiceIds.experianAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.oneBureauQuarterlyCreditReport,
        ezsServiceIds.oneBureauMonthlyCreditReport,
        ezsServiceIds.transCreditReport,
        idfServiceIds.threeBureauCreditReports,
        idfServiceIds.transUnionCreditReport,
        ezsServiceIds.tuCreditReport,
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuDailyCreditReport,
        ezsServiceIds.tuMonthlyCreditReport,
        ezsServiceIds.tuQuarterlyCreditReport,
        ezsServiceIds.tuCanadaQuarterlyCreditReport,
        ezsServiceIds.tuAnnualCreditReport,
        ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuAnnualCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCanadaMonthlyCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,
        ezsServiceIds.tuCanadaAnnualCreditReportWithScore,
        ezsServiceIds.tuCanadaOneTimeCreditReportWithScore,
    ];
    const creditSimulatorServiceList = [idfServiceIds.creditScoreSimulator];

    const isCreditScoreOrTrackerActive = useAreServicesActive(creditScoreAndTrackerServiceList) || (hasPurchaseCreditReport && hasOneTimeScore);
    const isCreditReportActive = useAreServicesActive(creditReportServiceList) || (hasPurchaseCreditReport && hasOneTimeReport);
    const isCreditSimulatorActive = useAreServicesActive(creditSimulatorServiceList);
    const [creditDynamicRoute, setCreditDynamicRoute] = useState("/credit/mycredit");

    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const businessProfileFlow = useSelector((state: ApplicationState) => getFlowByName(state, BUSINESS_PROFILE_STATUS));
    const businessAdditionalInformationFlow = useSelector((state: ApplicationState) => getFlowByName(state, ADD_YOUR_ADDITIONAL_BUSINESS_INFORMATION));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));

    const updateBusinessProfileDshboardGetStartedStatus = () => {
        const shouldBusinessProfileFlowUpdateToCompleteStatus: boolean =
            businessProfileFlow && businessProfileFlow.flowStepStatus !== FLOW_STEP_COMPLETED_STATUS ? true : false;
        if (shouldBusinessProfileFlowUpdateToCompleteStatus && businessProfileFlow) {
            completeGetStartedItem(businessProfileFlow.flowStepId, businessProfileFlow.flowName ? businessProfileFlow.flowName : " ");
        }
    };

    const updateBusinessAditionalInformationDshboardGetStartedStatus = () => {
        const shouldBusinessAditionalFlowUpdateToCompleteStatus: boolean =
            businessAdditionalInformationFlow && businessAdditionalInformationFlow.flowStepStatus !== FLOW_STEP_COMPLETED_STATUS ? true : false;
        if (shouldBusinessAditionalFlowUpdateToCompleteStatus && businessAdditionalInformationFlow) {
            completeGetStartedItem(
                businessAdditionalInformationFlow.flowStepId,
                businessAdditionalInformationFlow.flowName ? businessAdditionalInformationFlow.flowName : " "
            );
        }
    };

    const focusOnFamilyProtectionComponent = () => {
        const currentPath: string = window.location.pathname ? window.location.pathname : "";
        const isMyAccountPageOpened: boolean = currentPath.endsWith("/manage-account/my-account");

        if (isMyAccountPageOpened) {
            var element = document.querySelector("#family-protection");
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "end" });
            }

            const userProfile = document.getElementById("user-profile");

            if (userProfile) {
                var userMenu = document.querySelector("#user-profile");
                var toggleUser = document.querySelector("#user-profile-btn");
                if (userMenu && toggleUser && userMenu.classList.contains("is-active")) {
                    userMenu.classList.remove("is-active");
                    toggleUser.setAttribute("aria-expanded", "false");
                }
            }
        }
    };

    const prepareMenuDynamicRoute = () => {
        if (isBusinessUser) {
            // TODO: more permission will be added for business user.
            setCreditDynamicRoute("/credit/score");
        } else {
            if (isCreditScoreOrTrackerActive) {
                setCreditDynamicRoute("/credit/score");
            } else {
                if (isCreditReportActive) {
                    setCreditDynamicRoute("/credit/report");
                } else {
                    if (isCreditSimulatorActive) {
                        setCreditDynamicRoute("/credit/simulator");
                    } else if (hasPurchaseCreditReport) {
                        setCreditDynamicRoute("/credit/purchase");
                    } else {
                        setCreditDynamicRoute("/credit/mycredit");
                    }
                }
            }
        }
    };

    const serviceidsForLostWallet = [
        idfServiceIds.lostWalletAssistance,
        ezsServiceIds.idRestorationPro,
        ezsServiceIds.idRestorationProInd,
        ezsServiceIds.idDRestorationProWith1mInsurance,
        ezsServiceIds.idRestorationProWith25kInsurance,
        ezsServiceIds.familyIdRestorationPro,
        ezsServiceIds.familyIdRestorationProWith25kInsurance,
        ezsServiceIds.familyIdRestorationProWith1MInsurance,
        ezsServiceIds.businessIdRestorationPro,
        ezsServiceIds.businessIdRestorationClassic,
    ];
    const isLostWalletActive = useAreServicesAndFeatureActive(serviceidsForLostWallet, ["Product.Provide.VALUTFeature"]);

    const setChildAccountSwitchURL = (redirectURL: string) => dispatch(ConfigurationAction.actionCreators.setChildAccountSwitchURL(redirectURL));
    const switchFamilyAccount = (activeAccount: LoginTypes.IUserFamilyAccountInfo, familyMembers: LoginTypes.IUserFamilyAccountInfo[]) =>
        dispatch(LoginActions.actionCreators.switchFamilyAccount(activeAccount, history, familyMembers));
    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    const isPrimaryAccount: boolean = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );
    const isPrimaryAccountSwitchingNeeded: boolean = !isPrimaryAccount;

    const requestAccountSwitchToPrimaryAccount = () => {
        const requestBody = { SubcustomerId: "PRIMARY" };
        const accountToSwitch = familyMembers.find((x) => x.subcustomerId === "PRIMARY");
        Service.switchFamilyAccount(requestBody).then((data) => {
            if (!data["hasError"] && data["familyMembers"]) {
                if (accountToSwitch) {
                    switchFamilyAccount(accountToSwitch, data["familyMembers"]);
                    history.push("/switch-account");
                }
            }
        });
    };

    const redirectPageTo = (redirectURL: string) => {
        if (isPrimaryAccountSwitchingNeeded) {
            setChildAccountSwitchURL(redirectURL);
            requestAccountSwitchToPrimaryAccount();
        } else {
            history.push(redirectURL);
        }
    };

    useEffect(prepareMenuDynamicRoute, [service, creditHistory]);

    return (
        <CommonContext.Provider
            value={{
                creditDynamicRoute: creditDynamicRoute,
                updateBusinessProfileDshboardGetStartedStatus,
                updateBusinessAditionalInformationDshboardGetStartedStatus,
                redirectPageTo,
                isLostWalletActive,
                focusOnFamilyProtectionComponent,
            }}
        >
            {props.children}
        </CommonContext.Provider>
    );
};
export default CommonContextProvider;
